/* unplugin-vue-components disabled */import script from "./CinemaHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./CinemaHeader.vue?vue&type=script&lang=ts&setup=true"

import "./CinemaHeader.vue?vue&type=style&index=0&id=767262a6&lang=scss"

const __exports__ = script;

export default __exports__